angular.module('dnecom')
       .directive('validationExclude', ["$parse", function($parse) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, ngModelController) {
                    var excludedValues = $parse(attrs.validationExclude)(scope);

                    ngModelController.$validators.validationExclude = function(modelValue, viewValue) {
                        if (ngModelController.$isEmpty(modelValue)) {
                            return true;
                        }

                        if (!excludedValues || excludedValues.length == 0) {
                            throw "validationExclude directive requires some excluded values to be present";
                        }

                        return excludedValues.indexOf(viewValue) == -1;
                    }
                }
            };
        }]);
